export default "__VITE_ASSET__CzwPSkJp__"